"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const odata_filter_builder_1 = require("odata-filter-builder");
function builder(baseOperator = "and") {
    function finalizeOdata() {
        const filterString = this.toString();
        if (filterString.startsWith("$filter="))
            return filterString;
        return `$filter=${filterString}`;
    }
    odata_filter_builder_1.ODataFilterBuilder.prototype.toOData = finalizeOdata;
    odata_filter_builder_1.ODataFilterBuilder.prototype.build = finalizeOdata;
    return (0, odata_filter_builder_1.ODataFilterBuilder)(baseOperator);
}
exports.default = builder;
